import { useState, useEffect } from 'react'
import type { Partner } from '../types/partner'
import { getCurrentPartner } from '../services/partnerService'
import { useAuth } from '../contexts/AuthContext'

export function usePartner() {
  const { user, claims } = useAuth()
  const [partner, setPartner] = useState<Partner | null>(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!user || claims?.role !== 'partner') {
      setPartner(null)
      return
    }

    let cancelled = false
    setLoading(true)
    setError(null)

    getCurrentPartner()
      .then((p) => {
        if (!cancelled) setPartner(p)
      })
      .catch((err) => {
        if (!cancelled) setError(err?.message ?? 'Erro ao carregar dados do parceiro.')
      })
      .finally(() => {
        if (!cancelled) setLoading(false)
      })

    return () => { cancelled = true }
  }, [user, claims])

  return { partner, loading, error }
}
